var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("设置中心")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "APP备案号", prop: "recordNumber" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.recordNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "recordNumber", $$v)
                          },
                          expression: "form.recordNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "APP版权申明", prop: "copyright" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.copyright,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "copyright", $$v)
                          },
                          expression: "form.copyright",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }